export default class SaldoRepresentante {

  constructor(params) {
    const data = params || {};
    this.vlrPlanejado = data.vlrPlanejado ? data.vlrPlanejado : 0;
    this.vlrConsumido = data.vlrConsumido ? data.vlrConsumido : 0;
    this.vlrReservado = data.vlrReservado ? data.vlrReservado : 0;
    this.vlrConfNegociacao = data.vlrConfAcao ? data.vlrConfAcao : 0;
    this.vlrConfApuracao = data.vlrConfApuracao ? data.vlrConfApuracao : 0;
    this.vlrDisponivel = data.vlrDisponivel ? data.vlrDisponivel : 0;
  }

}



// WEBPACK FOOTER //
// ./src/custom/abbrasil/spa/dashboard/cadeia/orcamento/SaldoRepresentante.js